import cx from 'classnames';
import React from 'react';
import Rating from '../FeedbackRating';
import HTMLContent from '../HTMLContent';
import MarkdownRenderer from '../MarkdownRenderer';
import Title from './Title';
import { appendClassSuffix } from './utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CampusBody = _ref => {
  let {
    body,
    markdown,
    title
  } = _ref;
  return ___EmotionJSX("div", {
    className: "dc-sct-feedback__campus-content"
  }, ___EmotionJSX(Title, {
    title: title
  }), ___EmotionJSX(HTMLContent, {
    className: "dc-sct-feedback__text",
    html: body,
    mathJaxEnabled: true
  }), markdown && ___EmotionJSX(MarkdownRenderer, {
    markdown: markdown,
    theme: 'LIGHT'
  }));
};
const Body = _ref2 => {
  let {
    body,
    children,
    isActive,
    markdown,
    messageType,
    rating,
    title
  } = _ref2;
  if (!isActive) {
    return null;
  }
  return ___EmotionJSX("div", {
    className: cx('dc-sct-feedback__body', appendClassSuffix('dc-sct-feedback__body', messageType))
  }, ___EmotionJSX("div", {
    className: "dc-sct-feedback__content"
  }, children, title && body && ___EmotionJSX(CampusBody, {
    body: body,
    markdown: markdown,
    title: title
  })), rating && ___EmotionJSX(Rating, rating));
};
export default Body;